import { ConcreteEncodable } from "./ConcreteEncodable";

import { PortfolioForwardPriceResultImplEncoder } from "../../encoder/PortfolioForwardPriceResultImplEncoder";

import * as CubiqTS from "../../index";
import { PortfolioForwardPriceResult } from "../PortfolioForwardPriceResult";

export class PortfolioForwardPriceResultImpl
  extends ConcreteEncodable
  implements PortfolioForwardPriceResult
{
  public static enType: string = "com.bcdfx.service.PortfolioForwardPriceResultImpl";

  /*FID=1*/
  public portfolioId: string;
  /*FID=2*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = PortfolioForwardPriceResultImplEncoder.Instance;
    this.setEncodableType(PortfolioForwardPriceResultImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "PortfolioForwardPriceResultImpl[" +
      "portfolioId=" +
      this.portfolioId +
      "errors=" +
      this.errors +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
